import { graphql, useStaticQuery } from 'gatsby';
import React, { type FC } from 'react';
import { navigationData } from '../../../../../data';
import type { StrapiArticleType } from '../../../../../templates/post/types';
import { NavbarButton } from '../navbar-button';

interface LinksProps {
    postTranslatedSlugs: StrapiArticleType[] | undefined;
}

const Links: FC<LinksProps> = ({ postTranslatedSlugs }) => {
    const {
        site: {
            siteMetadata: { supportedLanguages },
        },
    } = useStaticQuery(
        graphql`
            query {
                site {
                    siteMetadata {
                        supportedLanguages
                    }
                }
            }
        `,
    );

    const links = navigationData.navbarItems;

    return (
        <>
            {links.map((link, index) => (
                <NavbarButton
                    link={link}
                    index={index}
                    key={`navbar-button-${index + 1}`}
                    supportedLanguages={supportedLanguages}
                    postTranslatedSlugs={postTranslatedSlugs}
                />
            ))}
        </>
    );
};

export default Links;
